<template>
  <div>
    <v-container
      dense
      class="mt-9"
      v-if="loading"
      alig="center"
      justify="center"
    >
      <div>
        <v-row dense>
          <v-row dense class="mt-9">
            <v-row dense>
              <v-col>
                <v-card
                  elevation="0"
                  style="
                    border-radius: 10px;
                    position: relative;
                    overflow: visible;
                    background-color: transparent;
                  "
                >
                  <v-card-text style="background-color: transparent">
                    <v-row dense style="padding: 2vh">
                      <v-col
                        class="d-flex align-start justify-center flex-column"
                      >
                        <div
                          class="d-flex align-start justify-start flex-column"
                        >
                          <strong style="font-size: 2rem; color: #ff5595"
                            >👋 Hi, {{ customerName }}! All good ?</strong
                          >
                          <v-img
                            class="mt-4"
                            heigth="10vh"
                            contain
                            width="15vw"
                            src="@/assets/images/dashboard/mensalidade.png"
                          />
                        </div>
                        <div class="mt-10">
                          <v-img
                            class="mt-4"
                            heigth="10vh"
                            contain
                            width="35vw"
                            src="@/assets/images/dashboard/ideas.png"
                          />
                        </div>
                        <div>
                          <v-img
                            class="mt-4"
                            heigth="10vh"
                            width="35vw"
                            contain
                            src="@/assets/images/dashboard/homework.png"
                          />
                        </div>
                      </v-col>
                      <v-col
                        class="d-flex align-start justify-center flex-column"
                      >
                        <div class="mt-10">
                          <v-img
                            heigth="10vh"
                            width="35vw"
                            contain
                            src="@/assets/images/dashboard/classes.png"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card> </v-col></v-row></v-row
        ></v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
export default {
  name: "CustomerDashboard",
  created() {},
  computed: {
    customerName() {
      return this.$store.getters.getName.split(" ")[0];
    },
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>
<style lang="css" scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}

.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}

.normal {
  text-transform: none;
}
</style>
